module.exports = __webpack_public_path__ + "img/play.c6fd783f.svg";